import { useCurrentBox } from "@modules/box/useBox"
import { useServicesContext } from "@modules/core/services/services.context"
import { TransactionTotalsEntity } from "@modules/finances/entities/transactionTotalsEntity"
import { useQuery } from "@tanstack/react-query"

export const useTransactionTotals = (period: string) => {
  const { result: boxId } = useCurrentBox()
  const { boxFinanceApi, userFinanceApi } = useServicesContext()
  const financeApi = boxId ? boxFinanceApi : userFinanceApi
  const apiKey = boxId ? "boxTransactionTotals" : "userTransactionTotals"

  const { data, isLoading, isError } = useQuery({
    queryKey: [apiKey, period],
    queryFn: async () => {
      return financeApi.getTransactionTotals(period)
    },
  })

  return {
    data: data ? TransactionTotalsEntity.fromDto(data) : undefined,
    isLoading,
    isError,
  }
}
